// @flow

import * as React from 'react';
import {DropDownSelector, UncontrolledContentGroup} from 'docs/components';
import {ContentGroupItem} from 'docs/util';

type SelectTabGroupProps = {|
  items: Array<ContentGroupItem>,
  defaultValue?: string,
  label?: string,
|};

// NOTE: This component is deprecated. Please use <TabGroup selector="drop-down" /> instead.
// TODO (nkohari): Remove this once we won't cause breakage by doing so.
export const SelectTabGroup = ({
  items,
  defaultValue,
  label,
}: SelectTabGroupProps) => (
  <UncontrolledContentGroup
    className="SelectTabGroup"
    items={items}
    initialSelectedId={defaultValue}
    selector={<DropDownSelector label={label} />}
  />
);
